export default "__VITE_ASSET__CmGOPyG3__"